import { ListItem } from '@thebouqs/ui';
import useStatic from '@/hooks/useStatic';
import useTranslation from '@/hooks/useTranslation';
import useUser from '@/hooks/useUser';
import selectUserType from '@/store/user/selectors/selectUserType';
import { getSubscriptionRoute } from '@/routes';
import { SFErrorBoundary } from '@/components/ErrorBoundary';
import MenuItemErrorFallback from '@/components/TopNav/MenuItemErrorFallback';
import NavDotw from '@/components/TopNav/NavDotw';
import MenuLink from '../MenuLink';

const TopMenu = (): JSX.Element => {
  const { navigation } = useStatic();
  const { t } = useTranslation();
  const user = useUser();
  const { isSubscriber } = selectUserType(user);
  const menuData = navigation?.menu[0]?.children;

  return menuData ? (
    <>
      {menuData.map((linkData, index) => {
        const { link, name } = linkData;
        const subscriptionLink =
          isSubscriber && getSubscriptionRoute({ isSubscriber, link });

        if (subscriptionLink) {
          linkData.link = subscriptionLink;
          linkData.name = t('header.mySubscriptions');
        }

        return (
          link &&
          name && (
            <ListItem
              zIndex="base"
              data-testid={`top-menu-item-${index}`}
              key={`top-menu-item-${index}`}>
              <SFErrorBoundary
                fallbackComponent={<MenuItemErrorFallback />}
                targetComponent="MegaMenu TopMenu">
                <MenuLink variant="top" data={linkData} topLinkIndex={index} />
              </SFErrorBoundary>
            </ListItem>
          )
        );
      })}
      <ListItem data-testid="top-menu-item-dotw">
        <NavDotw />
      </ListItem>
    </>
  ) : null;
};

export default TopMenu;
